<div data-test="Hl-xy7na" class="dropdown-hover">
  <button data-test="9EnIKFkq" class="items-table__icon">
    <svg data-test="vTnmAAkB" class="icon__icon-more" width="3px" height="13px">
      <use xlink:href="#icon-more"></use>
    </svg>
  </button>
  <div
    data-test="oN1bh-CF"
    class="dropdown items-table__dropdown dropdown_bottom-right dropdown_arrow"
  >
    <div data-test="PU0vjOJg" class="dropdown__wrap">
      <ul data-test="PXsJGHSa" class="dropdown__menu" #menuList>
        <ng-content></ng-content>
        <li data-test="cenyqUFx" [hidden]="hasContent">
          <a data-test="5qhMN8G-">No actions avaliable</a>
        </li>
      </ul>
    </div>
  </div>
</div>
